import React from "react";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import { updateProfile } from "../../../../redux/profile/action";
import { useDispatch } from "react-redux";
import CustomReactQuill2 from "../../../Common/CustomeLabel/ReactQuill/CustomReactQuill2";
import { descriptionvalidation, titlevalidation } from "../../../Common/commonvalidation";

export default function ProfileModelExpertAbout({
  edittype,
  formData,
  setFormData,
  setModelExpertAbout,
}) {
  const dispatch = useDispatch();
  const initialValues = {
    about:
      formData?.expert?.about !== ""
        ? formData?.expert?.about
        : formData?.about || "",
    // national_id: formData?.expert?.national_id !== '' ? formData?.expert?.national_id : formData?.national_id || '',
    designation:
      formData?.expert?.designation !== ""
        ? formData?.expert?.designation
        : formData?.designation || "",
  };

  const validationSchema = Yup.object().shape({
    about: descriptionvalidation,
    // national_id: Yup.string().trim().required('This Field is Required').test('not-only-spaces', 'Please enter a valid value', value => value.trim() !== ''),
    designation: titlevalidation,
  });

  const handleSubmit = (values) => {
    const data = {
      type: "expert_about",
      about: values.about,
      national_id: values.national_id,
      designation: values.designation,
    };
    if (edittype == 1) {
      dispatch(updateProfile(data));
      setModelExpertAbout((state) => !state);
    } else {
      setFormData({
        ...formData,
        about: values.about,
        national_id: values.national_id,
        designation: values.designation,
      });
      setModelExpertAbout((state) => !state);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={validationSchema}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ setFieldValue, values, formik }) => (
        <>
          <button
            onClick={() => setModelExpertAbout((state) => !state)}
            className="btn close-button"
          >
            <img
              src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
              alt=""
            />
          </button>
          <Form>
            <ModalBody>
              <h4>Edit Profile </h4>
              <CustomReactQuill2
                value={values.about}
                setFieldValue={setFieldValue}
                name={"about"}
                title={"About"}
              />
              <ErrorMessage
                name="about"
                component="div"
                className="error"
              />

              <div className="form-group">
                <label className="label-s">Designation</label>
                <Field
                  className="form-control input"
                  type="text"
                  name="designation"
                  placeholder="Your Designation"
                />
                <ErrorMessage
                  name="designation"
                  component="div"
                  className="error"
                />
              </div>
            </ModalBody>
            <div className="modal-footer mt-3">
              <button className="btn" type="submit">
                Save
              </button>
            </div>
          </Form>
        </>
      )}
    </Formik>
  );
}
